module.exports = __webpack_public_path__ + "static/media/truck.2d04ddd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/truck.svg
// module id = 543
// module chunks = 0